module.exports = __webpack_public_path__ + "9a98ff68273f52b7752433dc5b09c66f.pdf";